export default __webpack_public_path__ + "static/Tara-42c5ae80e3375347e12304d4f4b8c96d.png";